import _                           from "lodash";
import React, {useEffect, useMemo} from 'react';
import styled                      from "styled-components";

import {useApi}     from "../../../hooks/useApi";
import {useEquity}  from '../../../hooks/useEquity';
import {useProfile} from "../../../hooks/useProfile";

const Container     = styled.div`
  display        : flex;
  flex-direction : row;
  padding        : 8px 16px;
`;

const Account       = styled.div`
  display        : flex;
  flex-direction : row;
  margin-right   : 24px;
  &:last-child {
    margin-right: 0;
  }
`

const AccountValue  = styled.div`
  display        : flex;
  flex-direction : row;
  align-items    : center;
  padding-right  : 0.5rem;
`

const AccountKey    = styled.div`
  display        : flex;
  opacity        : .6;
  flex-direction : row;
  align-items    : center;
  font-size      : .75rem;
  margin-right   : 8px;
`

export interface TradeHeaderProps {
  manualEquityReload?: Date
}

export const TradeHeader = (p: TradeHeaderProps) => {
  const { isAuth }              = useApi(),
        { client }              = useProfile(),
        { equity, loadEquity }  = useEquity();

  useEffect(() => {
    // Load immediately, before first interval
    if (isAuth && client?.clientPortfolioId) {
      loadEquity(client.clientPortfolioId);
    }

    const interval = setInterval(() => {
      if (isAuth && client?.clientPortfolioId) {
        loadEquity(client.clientPortfolioId);
      }
    }, 60000);
    return () => clearInterval(interval);
  }, [isAuth, client, loadEquity, p.manualEquityReload]);
  
  const available       = useMemo(() => {
    return _.sum([client?.creditLimit, equity?.client_portfolio?.balance])
  }, [client, equity]);

  const availableCash   = useMemo(() => {
    return _.sum([client?.creditLimit, equity?.client_cash_portfolio?.balance])
  }, [client, equity]);
  
  const availableMargin = useMemo(() => {
    return _.sum([client?.creditLimit, equity?.client_margin_portfolio?.balance])
  }, [client, equity]);
  
  return (
    <>
      <Container>
        <Account>
          <AccountKey>Account Equity:</AccountKey>
          {equity.client_portfolio && <AccountValue>{equity?.client_portfolio?.balance} {equity?.client_portfolio?.currency}</AccountValue>}
          {equity.client_cash_portfolio && <><AccountKey>Cash:</AccountKey><AccountValue>{equity?.client_cash_portfolio?.balance} {equity?.client_cash_portfolio?.currency}</AccountValue></>}
          {equity.client_margin_portfolio && <><AccountKey>Margin:</AccountKey><AccountValue>{equity?.client_margin_portfolio?.balance} {equity?.client_margin_portfolio?.currency}</AccountValue></>}
        </Account>
        {client?.creditLimit && <Account>
          <AccountKey>Credit Limit:</AccountKey>
          {equity?.client_portfolio && <AccountValue>{client.creditLimit} {equity?.client_portfolio?.currency}</AccountValue>}
          {equity?.client_cash_portfolio && <><AccountKey>Cash:</AccountKey><AccountValue>{client.creditLimit} {equity?.client_cash_portfolio?.currency}</AccountValue></>}
          {equity?.client_margin_portfolio && <><AccountKey>Margin:</AccountKey><AccountValue>{client.creditLimit} {equity?.client_margin_portfolio?.currency}</AccountValue></>}
        </Account>}
        {(available || availableCash || availableMargin) && <Account>
          <AccountKey>Available Trade Amount:</AccountKey>
          {equity?.client_portfolio && <AccountValue>{available} {equity?.client_portfolio?.currency}</AccountValue>}
          {equity?.client_cash_portfolio && availableCash && <><AccountKey>Cash:</AccountKey><AccountValue>{availableCash} {equity?.client_cash_portfolio?.currency}</AccountValue></>}
          {equity?.client_margin_portfolio && availableMargin && <><AccountKey>Margin:</AccountKey><AccountValue>{availableMargin} {equity?.client_margin_portfolio?.currency}</AccountValue></>}
        </Account>}
      </Container>
    </>
  )
}
